import { useGetFeaturedSoundPackages } from '@bpm-web-app/swr-hooks';
import { createAppRoutes, useCreateFilterParams } from '@bpm-web-app/utils';
import { ClickableGenres } from '../../clickable-genres/clickable-genres';
import { SeeMoreLayout } from '../../see-more-layout/see-more-layout';

export const FeaturedPacks = () => {
    const query = useCreateFilterParams();
    const { data: featuredSoundsData } = useGetFeaturedSoundPackages(query);
    return (
        <SeeMoreLayout
            contentType="pack"
            pageTitle="Featured Packs"
            count={featuredSoundsData?.pagination?.total || 0}
            itemBasePath={createAppRoutes.packs}
            data={
                featuredSoundsData?.data?.map((item) => ({
                    id: item.id,
                    image_url: item.artwork_url,
                    description: <ClickableGenres genres={item.Genre} />,
                    title: item.name,
                    slug: item.slug,
                    demo_file_url: item.demo_file_url,
                    demo_wave: item.demo_wave,
                    demo_file_url_2: item.demo_file_url_2,
                    demo_wave_2: item.demo_wave_2,
                    badge: item.badge
                })) || []
            }
        />
    );
};
